import ClearingAPI from '@shared/api';

export const {
    preferences: { post, get, upsert, upsertThresholds, getThresholds, getGroupedThreshold },
    securities: { getSecurities: getSecuritiesAll },
    rebalancingJob: { bulkUserRebalancing },
    tradeOrders: { createBulkTradeOrder, createTradeOrder, getTradeOrders, updateTradeOrder, getTradeOrderByJobId },
    riaNotifications: { updateNotification, riaNotifications },
} = ClearingAPI.settings;
